import { render } from "./SelecionarCsosn.vue?vue&type=template&id=ba56dc72&ts=true"
import script from "./SelecionarCsosn.vue?vue&type=script&lang=ts"
export * from "./SelecionarCsosn.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__